import registerThemeStore from "./stores/theme";

import registerBaseManager from "./managers/baseManager";

import registerFX from "./fx/fx";

import registerSidebarComponent from "./components/sidebarComponent";

import registerSidebarHelper from "./components/sidebarHelper";

import registerhideOnScrollController from "./components/scrollController";

import registerIndexTypewriter from "./components/indexTypewriter";

import registerSellerOnboarding from "./components/sellerOnboarding";

import landingPageSectionsObserver from "./components/landingPage";

import registerScrollToActive from "./components/scrolltoActive";

import sellerStateForm from "./components/sellerStateForm";

import registerEstateCarousel from "./components/estateCarousel";

import registerHistoryStackDirective from "./directives/historyStack";

export function initAlpine(Alpine) {
  // ---------------------------------------------------------------------------
  // STORES
  // ---------------------------------------------------------------------------

  registerThemeStore(Alpine);

  // ---------------------------------------------------------------------------
  // MANAGERS
  // ---------------------------------------------------------------------------

  registerBaseManager(Alpine);

  // ---------------------------------------------------------------------------
  // FX
  // ---------------------------------------------------------------------------

  registerFX(Alpine);

  // ---------------------------------------------------------------------------
  // COMPONENTS
  // ---------------------------------------------------------------------------

  registerSidebarComponent(Alpine);

  registerSidebarHelper(Alpine);

  registerhideOnScrollController(Alpine);

  registerSellerOnboarding(Alpine);

  registerScrollToActive(Alpine);

  registerIndexTypewriter(Alpine);

  landingPageSectionsObserver(Alpine);

  sellerStateForm(Alpine);

  registerEstateCarousel(Alpine);

  // ---------------------------------------------------------------------------
  // DIRECTIVES
  // ---------------------------------------------------------------------------

  registerHistoryStackDirective(Alpine);
}
